<script>
import { authComputed } from '@state/helpers'
// import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  // components: { VuePerfectScrollbar },
  props: {
    user: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {}
  },
  computed: {
    ...authComputed,
    getCompanyInfo: function () {
      return this.$store.state.appAuth.companyInfo || null
    },
    getMenu: function () {
      if (this.$store.state.auth.currentSession.user.is_superuser){
        return null
      }
      return this.$store.state.auth.currentSession ? this.$store.state.auth.currentSession.user.app_sections_tree : []
    }
  },
  methods: {
    toggleMenu() {
      this.$parent.toggleMenu()
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar()
    },
  },
}
</script>

<template>
  <!-- Topbar Start -->
  <div class="navbar-footer text-center" :style="[getCompanyInfo && getCompanyInfo.primary_color ? { 'background-color': getCompanyInfo.primary_color } : { 'background-color': '' }]">
    <ul class="m-0 p-0">
      <b-nav-item v-for="(entry, index) in getMenu" 
        :id="`first-lv-${index}-${entry.id}`" 
        :key="index" 
        :class="{ active: entry.active }"
        :to=" { path: entry.path }"
        v-show="'path' in entry && entry.path"
        class="list-unstyled topnav-menu m-0">
        <i :class="`fad ${entry.icon_name || 'fa-arrow-right'}`" ></i><br>
        {{ $t(`pages.${entry.name}`) }}
      </b-nav-item>
      <!-- <div v-for="(entry, index) in getMenu" :key="index+1000" >
        <b-nav-item v-for="(childsecondlv, chsecondlvidx) in entry.children" 
          :id="`second-lv-${chsecondlvidx}-${entry.id}-${childsecondlv.id}`" 
          :key="chsecondlvidx" 
          :class="{ active: childsecondlv.active }" 
          :to="{ path: childsecondlv.path }"
          class="list-unstyled topnav-menu m-0"
          v-show="'path' in childsecondlv && childsecondlv.path"
          >
          <FontAwesomeIcon fixed-width :icon="childsecondlv.icon_name || 'fa-arrow-right'" size="lg" /><br>
          {{ childsecondlv.name }}
        </b-nav-item>
      </div> -->
    </ul>
  </div>
  <!-- end Topbar -->
</template>

<style lang="scss">
.noti-scroll {
  height: 220px;
}
.ps > .ps__scrollbar-y-rail {
  width: 8px !important;
  background-color: transparent !important;
}
.ps > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps.ps--in-scrolling.ps--y > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:active > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:hover > .ps__scrollbar-y {
  width: 6px !important;
}
.button-menu-mobile {
  outline: none !important;
}
</style>
